import type { AssetInfo } from "../net/api";
import { hint } from "../state/touch";

/** What the crosshair is on in the room: a model on the shelf, a page sign, or nothing. */
export type Look = { kind: "slot"; code: string } | { kind: "sign"; dir: -1 | 1 } | null;

export function sameLook(a: Look, b: Look): boolean {
  if (!a || !b) return a === b;
  return a.kind === "slot" ? b.kind === "slot" && a.code === b.code : b.kind === "sign" && a.dir === b.dir;
}

export function promptFor(look: Look, assets: readonly AssetInfo[], failed: (code: string) => boolean): string | null {
  if (!look) return null;
  if (look.kind === "sign") return look.dir < 0 ? hint("[E] 上一頁", "點「上一頁」") : hint("[E] 下一頁", "點「下一頁」");
  const a = assets.find((x) => x.code === look.code);
  const name = a ? `${a.name}（${a.code}）` : look.code;
  return failed(look.code) ? `${name}　無法載入，${hint("[E] 看健檢", "點「健檢」")}` : `${name}　${hint("[E] 檢查", "點「檢查」")}`;
}

/** The touch button's word for what the crosshair is on (spec 2p §2.2). */
export function actionFor(look: Look, failed: (code: string) => boolean): string | null {
  if (!look) return null;
  if (look.kind === "sign") return look.dir < 0 ? "上一頁" : "下一頁";
  return failed(look.code) ? "健檢" : "檢查";
}
